 <app-layout>
    <mat-toolbar class="page-header" role="heading">
        <h1 appLocalizationPopupDirective [localizationCode]="'TimeOffCalculationEntriesReport'">{{ 'TimeOffCalculationEntriesReport' | translate: {Default: "Time Off Calculation Entries Report"} }}</h1>
    </mat-toolbar>

    <div class="timeoff-calculation-entries-report content">
        <mat-card>
            <mat-card-content>
                <form class="form-fields" [formGroup]="form">
                    <app-employee-form-field
                        [formElement]="formElements[0]"
                        [parentGroup]="form"
                    >
                    </app-employee-form-field>

                    <mat-form-field appearance="fill">
                        <mat-label>
                            {{ 'TimeOffType' | translate: {Default: "Time Off Type"} }}
                        </mat-label>

                        <mat-select disableOptionCentering formControlName="timeoffTypeId">
                            <ng-container *ngIf="timeOffTypeList?.length > 0">
                                <mat-option></mat-option>
                                <ng-container *ngFor="let timeOffTypeOption of timeOffTypeList">
                                    <mat-option [value]="timeOffTypeOption.timeOffType?.id">{{ timeOffTypeOption.timeOffType?.name }} - {{ timeOffTypeOption.timeOffPolicy?.name }}</mat-option>
                                </ng-container>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </form>

                <app-local-data-grid-comp
                    class="calculation-log-data-grid"
                    [sort]="sort"
                    [columns]="columns"
                    [data]="data"
                    [isLoading]="isLoading"
                    [pageable]="false"
                    category=""
                    export="excel"
                ></app-local-data-grid-comp>
            </mat-card-content>
        </mat-card>
    </div>
</app-layout>